import { useSearch } from "@tanstack/react-router";
import useLocales from "src/hooks/useLocales";

import { ContextType } from "../../context";
import useGetLinkTheme from "../../hooks/useGetLinkTheme";
import useSetLinkLang from "../../hooks/useSetLinkLang";
import useProductActionsStore from "../../store";

// ----------------------------------------------------------------------

export const useTranfersData = () => {
	const [state, actions] = useProductActionsStore();
	const { id, themeType, isFrame, subproduct }: any = useSearch({
		strict: false
	});

	const { translate } = useLocales();
	const { theme } = useGetLinkTheme();
	useSetLinkLang();

	const STEPS = [
		{ name: translate("transfers.select_entity"), icon: "ic:baseline-search" },
		{ name: translate("transfers.connection"), icon: "mdi:connection" },
		{ name: translate("transfers.selection"), icon: "tabler:list" },
		{ name: translate("transfers.review"), icon: "material-symbols:rate-review" }
	];

	const contextValue: ContextType = {
		state,
		actions,
		id,
		themeType,
		isFrame,
		theme,
		subproduct,
		product: "ASSETS_TRANSFER"
	};

	return { contextValue, STEPS, theme, step: state.step };
};

export default useTranfersData;
